import { dispatchSearchClickEvent, ESearchType, SEARCH_CLICK_EVENT } from 'browser/utils';
import { selectQueryString } from 'shared/selectors';
import { TReduxStore } from 'shared/types/redux';

export function handleClickSearchSuggestion(store: TReduxStore, data: { type: ESearchType }) {
  const queryString = selectQueryString(store.getState());

  if (!queryString || queryString.trim() === '') {
    return {
      success: false,
      error: 'Query string is empty',
    };
  }

  dispatchSearchClickEvent({ type: data.type });

  return {
    success: true,
    dispatchedEvent: SEARCH_CLICK_EVENT,
    eventDetail: { type: data.type },
  };
}
